import ClientService from '../../../services/client-service';
import getListContactDataQuery from '../../../graphql/query/get-list-contact-data.graphql';
import getListContactPersonDataQuery from '../../../graphql/query/get-list-contact-person-data.graphql';
import getListContactCompanyDataQuery from '../../../graphql/query/get-list-contact-company-data.graphql';
import getListContactPersonInternalDataQuery
  from '../../../graphql/query/get-list-contact-person-internal-data.graphql';
import getListContactNotParticipantDataQuery
  from '../../../graphql/query/get-list-contact-not-participant-data.graphql';
import getListDealTaskContactPersonDataQuery
  from '../../../graphql/query/get-list-deal-task-contact-person-data.graphql';
import getListNotLinkedUserDataQuery from '../../../graphql/query/get-list-user-data.graphql';
import getListDealDataQuery from '../../../graphql/query/get-list-deal-data.graphql';
import getListActivityDealDataQuery from '../../../graphql/query/get-list-activity-deal-data.graphql';
import getListDealAssetDataQuery from '../../../graphql/query/get-list-deal-asset-data.graphql';
import getListTagDataQuery from '../../../graphql/query/get-list-tag-data.graphql';

export default class SearchListApi {
  public static getListContactData(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlQueryRequest(getListContactDataQuery, payload);
  }

  public static getListContactPersonData(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlQueryRequest(getListContactPersonDataQuery, payload);
  }

  public static getListContactCompanyData(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlQueryRequest(getListContactCompanyDataQuery, payload);
  }

  public static getListContactPersonInternalData(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlQueryRequest(getListContactPersonInternalDataQuery, payload);
  }

  public static getListContactNotParticipantData(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlQueryRequest(getListContactNotParticipantDataQuery, payload);
  }

  public static getListDealTaskContactPersonData(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlQueryRequest(getListDealTaskContactPersonDataQuery, payload);
  }

  public static getListNotLinkedUserData(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlQueryRequest(getListNotLinkedUserDataQuery, payload);
  }

  public static getListDealData(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlQueryRequest(getListDealDataQuery, payload);
  }

  public static getListActivityDealData(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlQueryRequest(getListActivityDealDataQuery, payload);
  }

  public static getListDealAssetData(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlQueryRequest(getListDealAssetDataQuery, payload);
  }

  public static getListTagData(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlQueryRequest(getListTagDataQuery, payload);
  }
}
